import apiClient from "@/libs/axios";
// import store from "@/state/store";
// import router from "@/router";

export const state = {
    data: [],
    vendorStats: [],
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setUserInfo: (state, data) => {
        state.data = data.result;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    setVendorStats: (state, data) => {
        state.vendorStats = data.result;
    },

    unsetData: (state) => {
        state.data = [];
        state.vendorStats = [];
        state.total = {
            totalItems: 0,
            totalPages: 0,
        };
    },
};

export const actions = {
    async unsetData({commit}) {
        commit('unsetData');
    },
    async info({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .get(`api/v1/vendors/show?id=${data.id}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setUserInfo', response.data);
                }
                commit('app/loadingFinish', null, {root: true});
            })
            .catch(error => {
                throw error;
            },);
        commit('app/loadingFinish', null, {root: true});
    },

    async vendorStats({ commit }, data) {
        await apiClient
            .get(`api/v1/users/vendors/stats/full?id=${data.id}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setVendorStats', response.data);
                }
                commit('app/loadingFinish', null, {root: true});
            })
            .catch(error => {
                throw error;
            },);
    },


};

export const getters = {
    getUserInfo(state) {
        return state.data;
    },
    getVendorStats(state) {
        return state.vendorStats;
    },
    getTotal(state) {
        return state.total;
    },
};
